"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.components_en_us = void 0;
function components_en_us() {
    return {
        "components.container.direction.vertical": "Vertical",
        "components.container.direction.horizontal": "Horizontal",
        "components.container.flexattributes.flex-start": "Start",
        "components.container.flexattributes.center": "Center",
        "components.container.flexattributes.flex-end": "End",
        "components.container.flexattributes.stretch": "Stretch",
        "components.container.flexattributes.normal": "Normal",
        "components.container.flexattributes.space-between": "With Space Between",
        "components.container.flexattributes.space-around": "With Space Around",
        "components.container.flexattributes.space-evenly": "With Space Evenly",
        "components.crm.contacts.detail.title": "Contact Details",
        "components.crm.contacts.avatar": "Avatar",
        "components.crm.contacts.firstname": "First Name",
        "components.crm.contacts.lastname": "Last Name",
        "components.crm.contacts.email": "Email",
        "components.crm.contacts.phone": "Phone",
        "components.crm.contacts.mobile": "Mobile",
        "components.crm.contacts.birthday": "Birthday",
        "components.crm.contacts.address": "Private Address",
        "components.crm.contacts.company": "Company Name",
        "components.crm.contacts.companyposition": "Position",
        "components.crm.contacts.companyphone": "Company Phone",
        "components.crm.contacts.companyaddress": "Company Address",
        "components.crm.contacts.deletion.title": "Delete contact",
        "components.crm.contacts.deletion.message": "Do you really want to delete this contact?",
        "components.editors.monaco.editorloading": "Editor is loading",
        "components.editors.styleeditor.csstitle": "Custom Styles",
        "components.editors.styleeditor.cssclasstitle": "Custom CSS Classes",
        "components.editors.styleeditor.cssclasshint": "Here you can add your own css classes",
        "components.editors.styleeditor.addnewstyle": "Add new style",
        "components.passwordreset.title": "Password Reset",
        "components.passwordreset.verificationtext": "Please enter your email address. We will send you the necessary instructions about how to reset your password!",
        "components.passwordreset.sendresetmailbtn": "Send recovery mail",
        "components.passwordreset.pendingtext": "A mail with further instructions has been sent, please check your mailbox.",
        "components.passwordreset.newpasswordtext": "Please type in your new password in the field below!",
        "components.passwordreset.changepasswordbtn": "Change password",
        "components.passwordreset.fields.email.label": "Registered E-Mail Address",
        "components.passwordreset.fields.resettoken.label": "Reset Token",
        "components.passwordreset.fields.password.label": "New Password",
        "components.passwordreset.messages.nopasswordgiven": "No password given!",
        "components.passwordreset.messages.passwordsdontmatch": "Passwords don't match!",
        "components.passwordreset.messages.nomailgiven": "No E-Mail given!",
        "components.passwordreset.messages.novalidmailgiven": "The e-mail address is ivalid!",
        "components.passwordreset.passwordresetmailsent": "Please check your mailbox for mails. If there is an account for this e-mail, you should have received a mail with further instructions.",
        "components.passwordreset.expiredtoken": "The password reset token has expired!",
        "components.passwordreset.unknowntoken": "The password reset token is unknown!",
        "components.passwordreset.passwordset": "Your new password was saved successfully!",
        "components.passwordreset.newtoken.text": "If the token has expired, then create a new one by clicking here",
        "components.passwordreset.newtoken.link": "Create new token",
        "components.passwordfield.password.label": "New Password",
        "components.login.label": "Login",
        "components.login.description": "Please login with your credentials!",
        "components.login.loginbutton": "Login",
        "components.login.emailpassword.fields.email.label": "E-Mail",
        "components.login.emailpassword.fields.password.label": "Password",
        "components.login.registration.label": "You don't have an account yet?",
        "components.login.registration.link": "Register here",
        "components.login.loginbtn": "Login",
        "components.login.headline": "Sign into your account",
        "components.login.mail": "E-Mail",
        "components.login.password": "Password",
        "components.login.remembercredentials": "Remember credentials",
        "components.login.notregistered": "Not registered yet?",
        "components.login.registerhere": "Register here",
        "components.login.forgotpassword": "Forgot password",
        "components.login.alreadyloggedin": "You are already logged in!",
        "components.login.errors.noauthenticationdetailsprovided": "No authentication details provided!",
        "components.login.errors.noauthenticationtypeprovided": "No authentication type provided!",
        "components.login.errors.unknownauthtype": "Unknown authentication type provided!",
        "components.login.errors.noemailgiven": "No E-Mail given!",
        "components.login.errors.nopasswordgiven": "No Password given!",
        "components.login.errors.unknownemailpassword": "Unknown username/password combination!",
        "components.login.errors.userdeactivated": "This user account is deactivated and therefor can't login!",
        "components.login.errors.invalidtoken": "The authentication token is invalid. Please login again!",
        "components.registration.email": "E-Mail",
        "components.registration.password": "Password",
        "components.registration.invitetoken.label": "Invitation Token",
        "components.registration.login.label": "Already got an account?",
        "components.registration.login.link": "Back to login",
        "components.registration.title": "Registration",
        "components.registration.message": "Just register with your email and a password and you're good to go!",
        "components.registration.registerbtn": "Create Account",
        "components.registration.hint": "Hint: You can make the password visible by clicking on the eye!",
        "components.registration.messages.lowercase": "contains at least one lower character",
        "components.registration.messages.uppercase": "contains at least one upper character",
        "components.registration.messages.minchars": "contains at least ${min} characters",
        "components.registration.messages.specialchar": "contains at least one special character",
        "components.registration.messages.digit": "contains at least one digit character",
        "components.registration.messages.passwordset": "Password successfully changed!",
        "components.registration.messages.invalidemail": "Email format invalid. Please use an email like hello@mail.com",
        "components.registration.messages.errortext": "There was an error during your registration. Please check your form inputs and try again!",
        "components.mailverification.title": "Mail Verification",
        "components.mailverification.message": "Thank you for verifying your e-mail. You can now login to the system.",
        "components.mailverification.titlemessageverificationsent": "Mail sent",
        "components.mailverification.messageverificationsent": "A new verification link has been sent via email.",
        "components.mailverification.invalidtoken": "The given mail verification token is invalid!",
        "components.mailverification.verificationmessage": "Please verify your email address '${email}'. We will send you an email with a confirmation link.",
        "components.mailverification.button": "Resend email",
        "components.mailverification.success.title": "Success!",
        "components.mailverification.success.message": "Your email has been successfully verified.",
        "components.mailverification.error.title": "Verification failure",
        "components.mailverification.error.token.expired": "The verification token has expired.",
        "components.mailverification.error.token.invalid": "The verificationtoken is invalid.",
        "components.mailverification.error.token.notprovided": "The verification token was not provided.",
        "components.mailverification.error.token.usernotfound": "The user was not found.",
        "components.pager.itemsperpagelabel": "per Page",
        "components.pager.firstpagelabel": "First Page",
        "components.pager.nextpagelabel": "Next Page",
        "components.pager.previouspagelabel": "Previous Page",
        "components.pager.lastpagelabel": "Last Page",
        "components.pager.of": "of",
        "components.register.headline": "Add new account",
        "components.register.confirmpassword": "Confirm password",
        "components.register.register": "Register",
        "components.register.registered": "Already registered?",
        "components.register.backtologin": "Go to login",
        "components.register.alreadyloggedin": "You are currently logged in. If you want to register another user, please log out first!",
        "components.register.passwordinvalid": "The given password doesn't fullfill the security requirements!",
        "components.register.passwordconfirmationinvalid": "The confirmed password doesn't match!",
        "components.cmsslot.add": "add new component",
        "components.cmscatalog.selectcomponent": "Select a component",
        "components.flexcontainer.add": "add component to flex container",
        "components.list.emptymessage": "No data found",
        "components.list.headers.actions": "Actions",
        "components.loader.loadingdata": "Loading Data",
        "components.cardboxes.actions.open": "open",
        "components.cardboxes.actions.del": "delete",
        "components.cardboxes.actions.edit": "edit",
        "components.cardboxes.actions.send": "send",
        "components.storeselect.selectcurrentpage": "Select All",
        "components.storeselect.unselectcurrentpage": "Select None",
        "components.siterefresh.title": "New Version Available",
        "components.siterefresh.message": "A new version of this web page is available. Refresh your browser to get the new version.",
        "components.siterefresh.refresh": "Refresh",
        "components.siterefresh.later": "Later",
        "components.deletedialog.title": "Confirm deletion",
        "components.deletedialog.message.xyz": "Are you sure you want to delete the file '${file}'?",
        "components.deletedialog.message.invitationslist": "Are you sure you want to delete this record?",
        "components.deletedialog.message.accesstoken": "Do you really want to delete this Access Token?",
        "components.deletedialog.message.custombackoffice": "Are you sure you want to delete this record?",
        "components.deletedialog.message.files": "Are you sure you want to delete the file?",
        "components.deletedialog.message.app": "Do you really want to delete this app?",
        "components.deletedialog.message.checkincontact": "Do you really want to delete this contact?",
        "components.deletedialog.message.checkinprinter": "Do you really want to delete this printer configuration?",
        "components.deletedialog.message.devices": "Do you really want to delete this device?",
        "components.deletedialog.message.languageeditor": "Do you really want to delete this language?",
        "components.deletedialog.message.countryeditor": "Do you really want to delete this country?",
        "components.deletedialog.message.localeeditor": "Do you really want to delete this locale?",
        "components.deletedialog.message.translations": "Do you really want to delete this translation?",
        "components.deletedialog.message.products": "Do you really want to delete this product?",
        "components.deletedialog.message.pricezone": "Do you really want to delete this price zone?",
        "components.deletedialog.message.supplier": "Do you really want to delete this supplier?",
        "components.deletedialog.message.price": "Do you really want to delete this price?",
        "components.deletedialog.message.productoption": "Do you really want to delete this product option?",
        "components.deletedialog.message.productpicture": "Do you really want to delete this product picture?",
        "components.deletedialog.message.productmeta": "Do you really want to delete this data?",
        "components.deletedialog.message.configuration": "Do you really want to delete this configuration?",
        "components.deletedialog.message.emailtemplate": "Do you really want to delete this email template?",
        "components.deletedialog.message.cms": "Do you really want to delete this CMS page together with all localized content, assigned tags and metadata?",
        "components.deletedialog.message.cmsmeta": "Do you really want to delete this data?",
        "components.deletedialog.message.optin": "Do you really want to delete this consent form?",
        "components.deletedialog.message.calendar": "Do you really want to delete this calendar '${calendar}'?",
        "components.deletedialog.delete": "Permanently delete",
        "components.deletedialog.cancel": "Cancel",
        "components.deletedialog.success.title": "Cleared successfully",
        "components.deletedialog.success.message": "The file was deleted successfully.",
        "components.actionbutton.clipboard": "Copied to clipboard",
        "components.inlinetranslation.replacement.title": "Remove Translation",
        "components.inlinetranslation.replacement.message": "This action will remove all saved translations and replace them with the currently displayed translation, do you want to continue?",
        "components.calendar.entryform.content": "Details",
        "components.calendar.entryform.title": "Title",
        "components.calendar.entryform.location": "Location",
        "components.calendar.entryform.start": "Start time",
        "components.calendar.entryform.end": "End time",
        "components.calendar.entryform.calendarid": "Calendar",
        "components.calendar.entryform.tags": "Tags",
        "components.calendar.entryform.category": "Categories",
        "components.calendar.entryform.attendeeids": "Attendees",
        "components.cms.editor.widgets.removetitle": "Remove Widget",
        "components.cms.editor.widgets.removemessage": "Do you really want to remove this widget? All of its data will be lost as well.",
        "components.cms.configuration.noconfig": "No configuration available",
        "components.qrcodeimage.aspng": "PNG Image",
        "components.qrcodeimage.assvg": "SVG Vector Image",
        "components.links.title": "Links",
        "components.links.unknowntype": "Unknown Type",
        "components.links.labels.customer": "Customer",
        "components.links.reversedlinks.nonefound": "No links found",
        "components.microsoftfiles.nofolderset": "No folder set",
        "components.microsoftfiles.changefolder": "Change Folder",
        "components.microsoftfiles.setfolder": "Set Folder",
        "components.microsoftfiles.openfolder": "Open Folder",
        "components.microsoftfiles.removefolder": "Unlink Folder",
        "components.microsoftfiles.dialogtitle": "Select Microsoft 365 folder",
        "components.microsoftfiles.directoryup": "Folder up",
        "components.microsoftfiles.nodrive": "No sharepoint folder linked",
        "components.orders.orderdate": "Order Date",
        "components.orders.orderer": "Orderer",
        "components.orders.empty": "No orders found",
        "components.cartdetails.pleaselogin": "Please login to use your shopping cart",
        "components.cartdetails.ordernow": "order now",
        "components.cartdetails.total": "Total Price",
        "components.cartdetails.noitems": "Your shopping cart is empty",
        "components.search.advancedsearch": "Advanced Search",
        "components.search.contains": "contains",
        "components.search.matches": "matches",
        "components.search.matcher.exactmatch": "matches",
        "components.search.matcher.equals": "matches",
        "components.search.matcher.includes": "includes",
        "components.search.matcher.startswith": "starts with",
        "components.search.matcher.endswith": "ends with",
        "components.search.matcher.exists": "field exists",
        "components.search.matcher.greaterthan": "greater than",
        "components.search.matcher.greaterthanequals": "greater than equals",
        "components.search.matcher.lessthan": "less than",
        "components.search.matcher.lessthanequals": "less than equals",
        "components.search.matcher.beforerelativetime": "before relative time",
        "components.search.matcher.afterrelativetime": "after relative time",
        "components.search.matcher.inrelativemonth": "in given month",
        "components.storesearch.mode.simple": "simple",
        "components.storesearch.mode.advanced": "advanced",
        "components.storesearch.comperator.or": "or",
        "components.storesearch.comperator.and": "and",
        "components.storesearch.placeholder": "Search by ${value}",
        "components.table.field": "Field",
        "components.table.key": "Key",
        "components.table.value": "Value",
        "components.table.addentry.text": "Text",
        "components.table.addentry.number": "Number",
        "components.table.addentry.boolean": "Yes/No"
    };
}
exports.components_en_us = components_en_us;
